<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <!-- dialog common header -->
    <popup-header v-on:clickClose="closeModal()"></popup-header>

    <!-- 제목 -->
    <div>
      <v-row class="title-wrap">
        <v-col cols="12" class="pa-0 pay-sheet-wrap">
          <v-sheet class="title-wrap">
            <v-row class="ma-0">
              <v-col cols="12" class="icon-title word-type px-6 py-0">
                급여계산방법
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>

      <!-- 계산방법 상세내용 -->
      <v-row class="ma-0 overflow-y-auto">
        <v-col cols="12" class="pa-0 pay-sheet-wrap">
          <!-- [ 수당 계산방법 ] -->
          <v-sheet class="pay-sheet">
            <v-row class="ma-0">
              <v-col cols="12" class="px-6 pt-0 sheet-title">
                수당 계산방법
              </v-col>
            </v-row>
            <v-list disabled>
              <v-list-item-group>
                <v-list-item  class="dflex flex-column cal-list">
                  <v-list-item-content>
                    <v-list-item-title class="pa-0 label">
                      기본급
                    </v-list-item-title>
                    <v-list-item-subtitle
                      class="pa-0 desc"
                    >월 기본급 * (실근로일수(<span>{{LAST_REAL_WORK_A}}</span>) / 월 소정근로일수(<span>{{LAST_REAL_WORK_B}}</span>))
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="pa-0 label">
                      법적 수당(포괄 OT 시간 기준)
                    </v-list-item-title>
                    <v-list-item-subtitle
                        class="pa-0 desc"
                    >월 법정수당 * (실근로일수(<span>{{LAST_REAL_WORK_A}}</span>) / 월 소정근로일수(<span>{{LAST_REAL_WORK_B}}</span>))
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="pa-0 label">
                      식대
                    </v-list-item-title>
                    <v-list-item-subtitle
                        class="pa-0 desc"
                    >월 식대 * (실근로일수(<span>{{LAST_REAL_WORK_A}}</span>) / 월 소정근로일수(<span>{{LAST_REAL_WORK_B}}</span>))
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="pa-0 label">
                      직책수당
                    </v-list-item-title>
                    <v-list-item-subtitle
                        class="pa-0 desc"
                    >월 직책수당 * (실근로일수(<span>{{LAST_REAL_WORK_A}}</span>) / 월 소정근로일수(<span>{{LAST_REAL_WORK_B}}</span>))
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-title class="pa-0 label">
                      자격수당
                    </v-list-item-title>
                    <v-list-item-subtitle
                        class="pa-0 desc"
                    >월 자격수당 * (실근로일수(<span>{{LAST_REAL_WORK_A}}</span>) / 월 소정근로일수(<span>{{LAST_REAL_WORK_B}}</span>))
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-content>
                    <v-list-item-action-text
                        class="pa-0 caution"
                    >
                      ※상기 실근로일수 및 월 소정근로일수에는 유급휴일과 유급휴가일이 포함됨
                    </v-list-item-action-text>
                    <v-list-item-action-text
                        class="pa-0 caution mt-1"
                    >
                      ※위 금액은 연봉계약상 금액을 기준으로 합니다.
                    </v-list-item-action-text>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-sheet>

          <!-- [ 공제 계산방법 ] -->
          <v-sheet class="pay-sheet">
            <v-row class="ma-0">
              <v-col cols="12" class="px-6 pt-0 sheet-title">
                공제 계산방법
              </v-col>
            </v-row>
            <v-list
              v-for="(item, i) in dedCalcList"
              :key="i"
              class="pay-list"
              flat
            >
              <v-list-item-group>
                <v-list-item :ripple="false">
                  <v-list-item-content>
                    <v-list-item-title class="col-6 pa-0 label">
                      {{ item.elementNm }}
                    </v-list-item-title>
                    <v-list-item-title
                      v-if="item.resultMonFor != undefined"
                      class="col-6 pa-0 desc text-right"
                    >
                      {{ item.resultMonFor }}
                    </v-list-item-title>
                    <v-list-item-title
                      v-else
                      class="col-6 pa-0 desc text-right"
                    >
                      -
                    </v-list-item-title>
                    <v-list-item-subtitle class="label sub">
                      {{ item.formula }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-sheet>

          <v-sheet class="pay-sheet">
            <v-row class="ma-0" v-if="payEtcList.length > 0">
              <v-col cols="12" class="px-6 pt-0 sheet-title">
                기타 계산방법
              </v-col>
            </v-row>
            <v-list
              v-for="(item, i) in payEtcList"
              :key="i"
              class="pay-list"
              flat
            >
              <v-list-item-group>
                <v-list-item :ripple="false">
                  <v-list-item-content>
                    <v-list-item-title class="col-6 pa-0 label">
                      {{ item.elementNm }}
                    </v-list-item-title>
                    <v-list-item-title
                      v-if="item.eleValue != undefined"
                      class="col-6 pa-0 desc text-right"
                    >
                      {{ item.eleValueUnit }}
                    </v-list-item-title>
                    <v-list-item-title
                      v-else
                      class="col-6 pa-0 desc text-right"
                    >
                      -
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-sheet>
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>

<script>
/* 급여명세서 계산방법 모달 */
import PopupHeader from '@/components/common/PopupHeader.vue';
import { getPayFormulaList, getPayEtcList, getPayFormulaListNew } from '@/api/payStatus.js';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **

export default {
  mixins: [dialogMixin],

  props: {
    payActionCdParam: {
      type: String,
    },
  },

  data: () => ({
    modalName: 'pay_calc_detail',

    payCalcList: [],
    dedCalcList: [],
    payEtcList: [],
    LAST_REAL_WORK_A: '',
    LAST_REAL_WORK_B: '',
  }),

  computed: {},

  watch: {
    dialog() {
      if (this.dialog) {
        //this.fetchPayFormulaList('A'); // 수당계산방법조회
        this.fetchPayFormulaList('D'); // 공제계산방법조회
        this.fetchPayEtcList(); //기타항목조회
        this.getPayFormulaListNew();
      }
    },
  },

  methods: {
    /* 급여명세서 항목조회 */
    async fetchPayFormulaList(type) {
      try {
        const response = await getPayFormulaList({
          searchPayActionCd: this.payActionCdParam,
          searchElementType: type,
        });
        const dataList = response.data.data;

        if (response != null && dataList != null) {
          if (type === 'A') this.payCalcList = dataList;
          else if (type === 'D') this.dedCalcList = dataList;
        }
      } catch (error) {
        console.log(error);
      }
    },
    /* 기타 항목조회 */
    async fetchPayEtcList() {
      try {
        const response = await getPayEtcList({
          searchPayActionCd: this.payActionCdParam,
        });
        const dataList = response.data.data;

        if (response != null && dataList != null) {
          this.payEtcList = dataList;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPayFormulaListNew() {

      const response = await getPayFormulaListNew({
        searchPayActionCd: this.payActionCdParam,
      });

      if (response.data.data != null) {
        this.LAST_REAL_WORK_A = response.data.data.lastRealWorkA;
        this.LAST_REAL_WORK_B = response.data.data.lastRealWorkB;
      }
    },
  },

  components: {
    PopupHeader,
  },
};
</script>
